import './HomePageCss/TestsSections.css';
import { use, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import heartImg from '../../Assets/DiseaseIcons/heart.png';
import kidneyImg from '../../Assets/DiseaseIcons/kidney.png';
import lungsImg from '../../Assets/DiseaseIcons/lungs.png';
import thyroidImg from '../../Assets/DiseaseIcons/thyroid.png';
import liverImg from '../../Assets/DiseaseIcons/liver.png';
import spinalImg from '../../Assets/DiseaseIcons/spine.png';

import AnimatedText from '../../AnimatedText';
import { fetchDeptList } from '../../api/api';
import HomeTestDetails from './HomeTestDetails';

export default function TestsSections() {
    const [showAll, setShowAll] = useState(false);
    const[organList,setOrganList] = useState([]);
    const [openModal, setOpenModal] = useState(false);
  const [selectedOrgan, setSelectedOrgan] = useState(null);


    useEffect(() => {
        fetchTestdepartList();
    }, []);

    const fetchTestdepartList = async () => {
       try{
        const response = await fetchDeptList();
        console.log("Department List:", response);
        setOrganList(response.data.data || []);
       }
       catch(err){
        console.error("Error fetching department list:", err);
       }
    }

     const viewTestDetails = (organ) => {
    console.log("View details for organ:", organ);
    setSelectedOrgan(organ);
    setOpenModal(true);
  };

    const testData = [
        { name: "Heart", link: "#", img: heartImg },
        { name: "Kidney", link: "#", img: kidneyImg },
        { name: "Lungs", link: "#", img: lungsImg },
        { name: "Thyroid", link: "#", img: thyroidImg },
        { name: "Liver", link: "#", img: liverImg },
        { name: "Spinal Disc", link: "#", img: spinalImg },
    ];

    // const visibleDiseases = showAll ? testData : testData.slice(0, 6);
    
    const visibleDiseases = showAll ? organList : organList.slice(0, 6);

    // Framer Motion Variants
    const containerVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.15,
            },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: 'easeOut' },
        },
    };

    return (
        <div className="TestsContainer">
            <div className="ourPackageUpperSection test-texts">
                {/*<h4 className="rb-headingTag pk-tag">Tests</h4>*/}

                <AnimatedText tag="h2" type="words" y={30} className="rb-title temp-title">
                    Explore Tests by Organ for Smarter Health Screening
                </AnimatedText>
                <p className="paraText abc">At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics,</p>

                <p className="paraText abc">our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.</p>


                <p className="paraText abcMobile">At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics, our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.</p>

                {/* <AnimatedText tag="p" type="words" y={-20} className="paraText abc">
                    At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics,
                </AnimatedText>
                <AnimatedText tag="p" type="words" y={-20} className="paraText abc">
                    our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.
                </AnimatedText>

                <AnimatedText tag="p" type="words" y={-20} className="paraText abcMobile">
                    At RB Diagnostic, we offer an extensive range of tests covering all major health parameters. From routine screenings to advanced diagnostics, our tests are designed to deliver accurate results with the highest precision—empowering you and your doctor to make informed health decisions at every step.
                </AnimatedText> */}
            </div>

            <motion.div
                className="diseaseSectionExplore"
                variants={containerVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
            >
                {visibleDiseases.map((d, indx) => (
                    <motion.div
                        className="cardDiseaseSection"
                        key={indx}
                        variants={cardVariants}
                        whileHover={{
                            transition: { type: 'spring', stiffness: 300, damping: 18 },
                        }}
                         onClick={() => viewTestDetails(d)}
                    >
                        <img src={d.organLink} alt={d.organName} />
                        <h2>{d.organName}</h2>
                        <p className="linksDieases">
                            <a href={d.link}>Explore Now</a>
                        </p>
                    </motion.div>
                ))}
            </motion.div>

            {organList.length > 6 && (
                <div className="viewMoreContainer">
                    <button
                        className="viewMoreBtn"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? "View Less" : "View All"}
                    </button>
                </div>
            )}
            {openModal && (
        
            <HomeTestDetails
           
              organData={selectedOrgan}
              onClose={() => setOpenModal(false)}
              setOpenModal={setOpenModal}
            />
        
      )}
        </div>
    );
}
